import {
  Box, Divider, List, ListItem, Typography,
} from '@mui/material';
import { Fragment } from 'react';
import { colorVariables } from '@/constants';
import CheckCircleIcon from '../CheckCircleIcon';

type Props = {
  steps: Array<string>;
  activeStep: number;
};

const CustomStepper = ({ steps, activeStep }: Props) => (
  <List sx={{
    display: 'flex', justifyContent: 'space-between', p: 0, gap: 1,
  }}
  >
    {steps.map((step, index) => (
      <Fragment key={step}>
        {index > 0 && (
        <Divider
          sx={{
            height: '1px',
            flexGrow: 1,
            alignSelf: 'center',
            backgroundColor: activeStep >= index ? colorVariables.primaryColor : '#CDD0CD',
            borderRadius: '8px',
          }}
        />
        )}
        <ListItem
          sx={{
            p: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            position: 'relative',
            width: 'max-content',
            alignItems:
              index === 0
                ? 'flex-start'
                : index === steps.length - 1
                  ? 'flex-end'
                  : 'center',
          }}
        >
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            gap={1}
          >
            {activeStep > index ? (
              <CheckCircleIcon
                width={24}
                height={24}
              />
            ) : (
              <Box
                sx={{
                  borderRadius: '50%',
                  backgroundColor: activeStep >= index ? colorVariables.primaryColor : '#969B96',
                  width: 24,
                  height: 24,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '0.75rem',
                  lineHeight: '20px',
                  letterSpacing: '0.4px',
                }}
              >
                {index + 1}
              </Box>
            )}
            <Typography
              fontSize={12}
              fontWeight={400}
              lineHeight='20px'
              letterSpacing='0.4px'
              color={activeStep >= index ? colorVariables.primaryColor : '#969B96'}
            >
              {step}
            </Typography>
          </Box>
        </ListItem>
      </Fragment>
    ))}
  </List>
);

export default CustomStepper;
